module.exports = __webpack_public_path__ + "fonts/FetteUNZFraktur.a69b63d8.otf";